import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=2a275ed6&scoped=true&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./PopupMessage.vue?vue&type=style&index=0&id=2a275ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a275ed6",
  null
  
)

export default component.exports